module.exports = __webpack_public_path__ + "static/man-woman-d072713e38e24a58a9ecf9b562614ce1.jpg";